var _a;
export var FULLSCREEN = {
    ALLOW_TITLE: 'controllers_fullscreen_allowTitleExpand',
    ALLOW_DESCRIPTION: 'controllers_fullscreen_allowDescriptionExpand',
    ALLOW_LINK: 'controllers_fullscreen_allowLinkExpand',
    WHEN_TO_SHOW_INFO: 'controllers_fullscreen_whenToShowInfo',
    EXPAND_INFO_POSITION: 'controllers_fullscreen_expandInfoPosition',
    SHOW_INFO_BUTTON: 'controllers_fullscreen_showInfoExpandButton',
    ALLOW_FULLSCREEN_EXPAND: 'controllers_fullscreen_allowFullscreenExpand',
    LOOP: 'controllers_fullscreen_fullscreenLoop',
    ALLOW_MAGNIFY_IMAGE: 'controllers_fullscreen_allowFullscreenMagnifyImage',
    MAGNIFICATION_LEVEL: 'controllers_fullscreen_fullscreenMagnificationLevel',
    BACKGROUND_BLUR_FILTER: 'controllers_fullscreen_backgroundBlurFilter',
    BACKGROUND_GRAYSCAL_EFILTER: 'controllers_fullscreen_backgroundGrayscaleFilter',
    FULLSCREEN_PREVIEW: 'FULLSCREEN_PREVIEW',
};
export var FULLSCREEN_CONTROLLERS = (_a = {},
    _a[FULLSCREEN.WHEN_TO_SHOW_INFO] = function (value) {
        var _a;
        var shouldToggleInfo = value === 'ON_TOGGLE';
        return _a = {},
            _a[FULLSCREEN.SHOW_INFO_BUTTON] = shouldToggleInfo,
            _a.defaultShowInfoExpand = !shouldToggleInfo,
            _a;
    },
    _a);
//# sourceMappingURL=fullscreen.js.map